import React from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { AxiosError } from 'axios';
import { useHistory } from 'react-router';
import {
  Box,
  Button,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { userVerification } from '../../requests/api/auth';
import handleApiResponse from '../../utils/handleApiResponse';

import useStyles from './styles';
import { PasswordFormProps } from '../PasswordRecovery/SetPasswordForm';

function SetPasswordForm({
  className, token, ...rest
}: PasswordFormProps) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const onSubmitSuccess = () => {
    history.push('/login');
  };

  return (
    <Formik
      initialValues={{
        password: '',
        confirmPassword: '',
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string().max(255).required('Contraseña requerida'),
        confirmPassword: Yup.string().max(255).required('Confirmación de contraseña requerida'),
      })}
      onSubmit={async (values, {
        setStatus,
        setSubmitting,
      }) => {
        try {
          const data = {
            token,
            password: values.password,
            confirmPassword: values.confirmPassword,
          };
          const res = await userVerification(data);

          handleApiResponse(enqueueSnackbar, res, true);
          setStatus({ success: true });
          setSubmitting(false);
          onSubmitSuccess();
        } catch (error) {
          const e = error as AxiosError;
          handleApiResponse(enqueueSnackbar, e, false);
          setStatus({ success: false });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          noValidate
          className={clsx(classes.rootSetPasswordForm, className)}
          onSubmit={handleSubmit}
          {...rest}
        >
          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            autoFocus
            helperText={touched.password && errors.password}
            label="Contraseña"
            margin="normal"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="standard"
          />
          <TextField
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            fullWidth
            helperText={touched.confirmPassword && errors.confirmPassword}
            label="Confirmar contraseña"
            margin="normal"
            name="confirmPassword"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.confirmPassword}
            variant="standard"
          />
          <Box mt={2}>
            <Button
              color="secondary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Verificar cuenta
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}

export default SetPasswordForm;
